"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("./");
var _helpers = require("../../../helpers");
var _uuid = _interopRequireDefault(require("uuid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class UpdatePasswordForm extends _react.default.Component {
  render() {
    const {
      auth,
      onSubmit,
      onChange,
      state,
      messages,
      error
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: onSubmit
    }, messages && messages.map(message => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: `alert ${(0, _helpers.getAlertClassName)(message.type)}`,
        role: "alert",
        key: _uuid.default.v4()
      }, message.text);
    }), error && error && /*#__PURE__*/_react.default.createElement("div", {
      className: "alert alert-danger",
      role: "alert"
    }, error), /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group col"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "oldPassword",
      className: 'text-muted text-uppercase'
    }, /*#__PURE__*/_react.default.createElement("small", null, "Current Password")), /*#__PURE__*/_react.default.createElement(_.PasswordInput, {
      type: 'password',
      id: 'oldPassword',
      name: 'old',
      value: state.old,
      onChange: event => onChange({
        old: event.target.value
      }),
      required: true
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group col"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "newPassword",
      className: 'text-muted text-uppercase'
    }, /*#__PURE__*/_react.default.createElement("small", null, "New Password")), /*#__PURE__*/_react.default.createElement(_.PasswordStrength, {
      onInputChange: event => onChange({
        new: event.target.value
      }),
      onPasswordValidate: valid => onChange({
        valid
      }),
      rules: auth.passwordRules
    }, /*#__PURE__*/_react.default.createElement(_.PasswordInput, {
      type: 'password',
      id: 'newPassword',
      name: 'new',
      value: state.new,
      onChange: this.onInputChange,
      required: true
    })))), /*#__PURE__*/_react.default.createElement("div", {
      className: "row pt-2"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: 'submit',
      className: "btn btn-primary"
    }, "Update"))));
  }
}
var _default = exports.default = UpdatePasswordForm;
module.exports = exports.default;